// Section for import npm components -----------------------------------------------------------------------------------
import React, { useContext } from 'react';

// Material UI ( mui )  components
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';

// Section for import custom components --------------------------------------------------------------------------------
import { AppConfigContext } from '@providers/AppConfigProvider';
import MansionSalesHistoryList from '@components/MansionDetail/MansionSalesHistory/MansionSalesHistoryList';
import MansionSalesHistoryListSp from '@components/MansionDetail/MansionSalesHistory/SP/MansionSalesHistoryList';

// Section for type definition -----------------------------------------------------------------------------------------
// import CommonUtilityClass from '@/types/CommonUtilityClass';
import SalesHistoryPropsData from '@/types/components/MansionDetail/SalesHistoryPropsData';

type SalesHistoryProps = {
  salesHistory: SalesHistoryPropsData;
};

export default function MansionSalesHistory(props: SalesHistoryProps): React.JSX.Element {
  const { isMobile } = useContext(AppConfigContext);
  const { salesHistory } = props;
  const salesHistoryContent =
    salesHistory && Array.isArray(salesHistory) && salesHistory.length > 0 ? (
      <Box id="section-sales-history">
        <Box className="md:max-w-7xl w-full mx-auto px-24 max-md:px-5 md:mb-16 max-md:mb-12">
          {isMobile ? (
            <MansionSalesHistoryListSp salesHistory={salesHistory} />
          ) : (
            <MansionSalesHistoryList salesHistory={salesHistory} />
          )}
          <Box className="rf-mansion-review">
            <Typography className="text-2xs mr-1">※</Typography>
            <Typography className="text-2xs">
              販売履歴は
              <Link
                href="https://www.mansion-review.jp/"
                underline="none"
                className="text-rf-blue font-bold underline"
                target="_blank"
              >
                マンションレビュー
              </Link>
              の提供により掲載しております。表示価格は成約価格ではなく、売り出し時の価格となります。
            </Typography>
          </Box>
        </Box>
      </Box>
    ) : null;

  return <Box>{salesHistoryContent}</Box>;
}
